import { useEffect } from 'react';

/**
 * DevToolsBlocker Component
 * Blocks developer tools (F12, Ctrl+Shift+I, Ctrl+U, Right-click) when enabled
 * 
 * Setting is stored in localStorage as 'devToolsBlocked'
 * - 'true' = Dev tools are BLOCKED (production mode)
 * - 'false' or not set = Dev tools are ALLOWED (development mode)
 */
const DevToolsBlocker = () => {
  useEffect(() => {
    // Block right-click context menu
    const handleContextMenu = (e) => {
      if (localStorage.getItem('devToolsBlocked') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // Block keyboard shortcuts
    const handleKeyDown = (e) => {
      if (localStorage.getItem('devToolsBlocked') !== 'true') {
        return true;
      }

      const key = e.key?.toUpperCase();
      const keyCode = e.keyCode || e.which;

      // F12 - Developer Tools
      if (key === 'F12' || keyCode === 123) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      
      // Ctrl+Shift combinations
      if (e.ctrlKey && e.shiftKey) {
        // I - Developer Tools, J - Console, C - Element Inspector
        if (['I', 'J', 'C'].includes(key) || [73, 74, 67].includes(keyCode)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }
      
      // Ctrl combinations (without shift)
      if (e.ctrlKey && !e.shiftKey) {
        // U - View Source, S - Save Page
        if (['U', 'S'].includes(key) || [85, 83].includes(keyCode)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }

      return true;
    };

    // Add event listeners with capture phase (runs before bubbling)
    // This ensures our handlers run first
    document.addEventListener('contextmenu', handleContextMenu, { capture: true, passive: false });
    document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
    window.addEventListener('contextmenu', handleContextMenu, { capture: true, passive: false });
    window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

    // Cleanup on unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu, { capture: true });
      document.removeEventListener('keydown', handleKeyDown, { capture: true });
      window.removeEventListener('contextmenu', handleContextMenu, { capture: true });
      window.removeEventListener('keydown', handleKeyDown, { capture: true });
    };
  }, []);

  return null;
};

export default DevToolsBlocker;
